import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import './Erro.scss';

function Erro(props) {
	const codigo = props.params.idErro;

	const erros = {
		'401': {
			titulo: 'Acesso não autorizado',
			mensagem: 'Você não tem permissão para acessar esta página. Verifique suas credenciais e tente novamente.',
		},
		'403': {
			titulo: 'Área restrita',
			mensagem: 'Esta área é restrita. Entre em contato com o administrador caso precise de acesso.',
		},
		'404': {
			titulo: 'Página não encontrada',
			mensagem: 'A página que você procura não existe ou foi movida. Verifique o endereço ou volte para o início.',
		},
	};

	const erro = erros[codigo] || {
		titulo: 'Erro inesperado',
		mensagem: 'Algo deu errado. Tente novamente ou volte para a página inicial.',
	};

	return (
		<div className="erro-page">
			<div className="erro-container">
				<div className="erro-icon">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
						{codigo === '401' || codigo === '403' ? (
							<>
								<rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
								<path d="M7 11V7a5 5 0 0 1 10 0v4" />
							</>
						) : (
							<>
								<circle cx="12" cy="12" r="10" />
								<path d="M16 16s-1.5-2-4-2-4 2-4 2" />
								<line x1="9" y1="9" x2="9.01" y2="9" />
								<line x1="15" y1="9" x2="15.01" y2="9" />
							</>
						)}
					</svg>
				</div>

				<h1 className="erro-codigo">{codigo}</h1>
				<h2 className="erro-titulo">{erro.titulo}</h2>
				<p className="erro-mensagem">{erro.mensagem}</p>

				<a href="https://www.econeteditora.com.br" className="erro-botao">
					<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
						<polyline points="9 22 9 12 15 12 15 22" />
					</svg>
					Voltar ao início
				</a>
			</div>
		</div>
	);
}

Erro.propTypes = {
	params: PropTypes.object.isRequired,
};

export default withRouter(Erro);
